var exports = {
  "d": "languageCircle__eF82_7",
};

module.exports = exports;
